import currency from "currency.js";
import { useTranslation } from "react-i18next";
import { InstrumentTypeResponse } from "../../../codegen-api";
import { COLORS } from "../../../constants/design/colors";
import { IPerpsMarket } from "../../../contexts/MarketInstrumentContext/useGetMarkets";
import { useMarkPriceWSS } from "../../../hooks/wss/useMarkPriceWSS";
import { getContractPriceStep } from "../../../utils/instruments";
import Stat from "../Stat";

interface IMarkPriceProps {
  mark24hAgo?: string;
  perpInstrument?: IPerpsMarket;
}

function Mark24hChange({ mark24hAgo, perpInstrument }: IMarkPriceProps) {
  const { t } = useTranslation("app", {
    keyPrefix: "TradingHeader.PerpsTradingHeader",
  });

  const m = useMarkPriceWSS(
    perpInstrument
      ? {
          instrumentName: perpInstrument.instrument_name,
          asset: perpInstrument.underlying_asset,
          derivative: InstrumentTypeResponse.Perpetual,
        }
      : undefined
  );
  const markPrice = m?.mark_price || perpInstrument?.mark_price;

  const changeValue =
    markPrice && mark24hAgo
      ? Number(markPrice) - Number(mark24hAgo)
      : undefined;

  const changePercentage =
    markPrice && changeValue ? changeValue / Number(mark24hAgo) : 0;

  const positiveChange = Boolean(changeValue && Number(changeValue) >= 0);
  const sign = positiveChange ? "+" : "";
  const mark24hChangeValue =
    changeValue !== undefined
      ? `${sign}${(changePercentage * 100).toFixed(2)}% (${sign}${currency(
          changeValue,
          { precision: getContractPriceStep(perpInstrument).price_precision }
        ).format()})`
      : "-";

  return (
    <Stat
      label={t("daily_change")}
      value={mark24hChangeValue}
      valueColor={
        changeValue
          ? positiveChange
            ? COLORS.positive.one
            : COLORS.negative.one
          : undefined
      }
    />
  );
}

export default Mark24hChange;
